const shuffle = (list, random) => {
    const copy = [...list];
    for (let i = copy.length - 1; i > 0; i -= 1) {
        const j = Math.floor(random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
};

const canShow = (product) => Boolean(product?.image) && product.countInStock > 0;

// A random mix of new and hand-picked products, different on each visit.
// The wall has one large photo and four smaller ones.
export const pickHeroProducts = ({ newArrivals = [], topPicks = [] }, limit = 5, random = Math.random) => {
    const fresh = shuffle(newArrivals.filter(canShow), random);
    const picks = shuffle(topPicks.filter(canShow), random);
    const picked = new Map();

    for (let i = 0; i < Math.max(fresh.length, picks.length); i += 1) {
        [fresh[i], picks[i]].forEach((product) => {
            if (product && picked.size < limit) picked.set(product._id, product);
        });
    }
    return [...picked.values()];
};
